module.exports = __webpack_public_path__ + "static/media/beaconManageTeam.ef71753c.jpg";